import { ImagingVisibility } from "../../../app/data/manifest/manifestProfiles";

export const IMAGING_COMPLETE_LABEL = "Imaging Complete";

export function formatMissingDocumentsLabel(documents: string[]): string {
  return `Missing ${documents.join(" & ")}`;
}

export function getImagingLabel(visibility: ImagingVisibility): string {
  if (visibility.status === "COMPLETE") {
    return IMAGING_COMPLETE_LABEL;
  }
  return formatMissingDocumentsLabel(visibility.missingDocuments);
}

export function getImagingStatusLabel(
  status: "COMPLETE" | "INCOMPLETE",
  missingDocuments: string[],
): string {
  return status === "COMPLETE"
    ? IMAGING_COMPLETE_LABEL
    : formatMissingDocumentsLabel(missingDocuments);
}